import { NoStationsPage } from '@app/core/auth/authentication/components/NoStationsPage';
import { useAuth } from '@app/core/auth/authentication/hooks';
import { useStations } from '@app/core/stations/hooks/useStations';
import { ModulesRoutes } from '@app/modules/ModulesRoutes';
import { useLocation } from 'react-router-dom';

/**
 * Paths that remain available when the user has no stations (profile, etc.).
 * Station-dependent modules stay behind NoStationsPage.
 */
function isAllowedWithoutStations(pathname: string): boolean {
  return pathname.startsWith('/settings');
}

/**
 * Main content for the authenticated app shell.
 * Shows NoStationsPage when a non-superadmin user has no stations, except on
 * routes that do not require stations (e.g. user settings).
 */
export function AppMainContent() {
  const { isSuperadmin } = useAuth();
  const stations = useStations();
  const { pathname } = useLocation();

  const hasNoStations = !isSuperadmin && stations.length === 0;

  if (hasNoStations && !isAllowedWithoutStations(pathname)) {
    return <NoStationsPage />;
  }

  return <ModulesRoutes />;
}
